'use strict';

import {EwSiteApp} from '../../app/ewsiteapp';

EwSiteApp.controller('NetshowFormCtrl', ['$scope', '$http', '$filter', '$uibModal', '$log', '$timeout', '$interval', '$sce', 'SessionService', function ($scope, $http, $filter, $uibModal, $log, $timeout, $interval, $sce, SessionService) {
	$scope.sumbitted = false;
	$scope.form;
	$scope.submitted = false;
	$scope.displayStatus = 0;
	$scope.navigation = netshowData.navigation;
	$scope.checkRegNrUrl = netshowData.checkRegNrUrl;
	$scope.checkFileUrl = netshowData.checkFileUrl;
	$scope.situation_title = [];
	$scope.checking_nr = false;
	$scope.excavation_nr_valid = false;
	$scope.check_data = {};
	$scope.number = '';
	$scope.excavation_end = '';
	$scope.form_type = '';
	$scope.setDisplayStatus = function (btn) {
		let title = '';
		if (arguments[1]) {
			title = arguments[1];
		}

		for (var i = 0, len = $scope.navigation.length; i < len; i++) {
			if ($scope.navigation[i].id == btn.question_id) {
				$scope.id = i;
				break;
			}
		}

		document.querySelector('.index_container').scrollIntoView({
			behavior: 'smooth'
		});
		if (btn.question_id > 0 && !title) {
			$scope.situation_title.push(btn.title);
		} else if (title) {
			$scope.situation_title.push(title);
		}
		if (btn.question_id == 0) {
			$scope.situation_title = [];
		}
		$scope.displayStatus = btn.question_id;

		switch ($scope.displayStatus) {
			case 1:
				$scope.form_type = 'individual';
				break;
			case 2:
				$scope.form_type = 'legal';
				break;
			case 3:
				$scope.form_type = 'contractor';
				break;
			default:
				break;
		}
		$scope.initTooltip();
	};
	$scope.resetFormData = function(){
		$scope.number = '';
		$scope.comp_title = '';
		$scope.comp_code = '';
		$scope.name_lastname = '';
		$scope.email = '';
		$scope.phone = '';
		$scope.work_description = '';
		$scope.municipality_id = '';
		$scope.address = '';
		$scope.investment_number = '';
		$scope.network_type = '';
		$scope.arrival_date = '';
	};
	$scope.resetFormData();

	$scope.$watch("phone", function (newVal) {
		if (newVal) {
			$scope.fullPhone = '+370' + newVal;
		} else {
			$scope.fullPhone = '';
		}
	});


	$scope.resetForm = function () {
		$scope.stepBack({back_id: 0});
		$scope.situation_title = [];
	};

	$scope.stepBack = function (btn) {
		$scope.checking_nr = false;
		$scope.check_data = {};
		$scope.error_message = '';
		$scope.excavation_nr_valid = false;
		$scope.resetFormData();
		if (btn.back_id >= 0) {
			btn.question_id = btn.back_id;
			for (var i = 0, len = $scope.navigation.length; i < len; i++) {
				if ($scope.navigation[i].id == btn.question_id) {
					$scope.id = i;
					break;
				}
			}
			$scope.displayStatus = btn.question_id;
			if ($scope.situation_title.length > 0) {
				$scope.situation_title.splice($scope.situation_title.length - 1, 1);
			}

			if ($scope.displayStatus === 1) {
				$scope.check_data = {};
			}
		} else {
//			if($scope.situation_title.length>0){
//				$scope.situation_title.splice($scope.situation_title.length-1, 1);
//			}
			$scope.navigation = netshowData.navigation;
			$scope.setDisplayStatus(0);
		}
		$scope.initTooltip();
	};

	$scope.getIconPath = function (form) {
		if (form.image) {
			return form.image;
		}
		return form.icon2;
	};

	$scope.explicitlyTrustedHtml = function (text) {
		return $sce.trustAsHtml(text);
	};

	$scope.checkRegNr = function (check_registration_nr, btn) {
		$scope.checking_nr = true;
		if ($scope.checkRegNrUrl !== '' && check_registration_nr !== '') {
			$http({
				method: 'POST',
				url: $scope.checkRegNrUrl,
				data: {
					nr: check_registration_nr
				},
				xsrfCookieName: secure_xsrf_name,
				xsrfHeaderName: 'X-' + secure_xsrf_name
			}).then(function (response) {
				$scope.regNrValid = response.data.success;
				if (response.data.success) {
					$scope.number = response.data.data.number;
					$scope.excavation_end = response.data.data.excavation_end;

					$scope.excavation_nr_valid = true;
				} else {
					if (response.data.message) {
						$scope.error_message = response.data.message;
					} else {
						$scope.error_message = "Server error";
					}
				}
			}, function (response) {
				console.log(['Error', response]);
			}).then(function () {
				$scope.checking_nr = false;

			});
		}
	};

	$scope.initTooltip = function () {
		$timeout(function () {
			if ($(".thirdpersonsprojects_form .tooltip, .status-1-holder .tooltip").length) {
				$(".thirdpersonsprojects_form .tooltip, .status-1-holder .tooltip").tooltipster({
					delay: 15,
					multiple: true
				});
			}
		});
	};

	var hideInfoContainers = function () {
		var $info = $('.index_container > .white_bg > .info_container');
		var $error = $('.index_container > .white_bg > .error_container');

		if ($info.length > 0 && $info.is(":visible")) {
			$info.remove();
		}

		if ($error.length > 0 && $error.is(":visible")) {
			$error.remove();
		}
	};

	$scope.onFormSelect = function () {
		$scope.initTooltip();
		hideInfoContainers();
	};


	$scope.formSubmit = function (e) {
		e.preventDefault();
		$scope.submitted = true;
		let is_grecaptcha = $scope.form.find('#g-recaptcha-response-hidden').length > 0;
		if (is_grecaptcha && typeof (grecaptcha) !== 'undefined') {
			grecaptcha.ready(function () {
				grecaptcha.execute($('#g-recaptcha-response-hidden').data('sitekey'), {action: 'submit'}).then(function (token) {
					if (document.getElementById('g-recaptcha-response-hidden')) {
						$('#g-recaptcha-response-hidden').val(token);
					} else {
						var inp = document.createElement('input');
						inp.type = 'hidden';
						inp.name = 'g-recaptcha-response';
						inp.value = token;
						$scope.form[0].appendChild(inp);
					}
					$scope.form[0].submit();
				});
			});
		} else {
			$scope.form[0].submit();
		}
	};
	
	SessionService.init();

	$scope.$on('$destroy', function() {
	  SessionService.stop();
	});
}]).directive('formSubmit', function () {
	return {
		restrict: 'A',
		link: function (scope, element, attr) {
			scope.form = angular.element(element);
		}
	};
});

